import disciplinaryRecord from '@/api/disciplinary-record'
import disciplinarySubType from '@/api/disciplinary-sub-type'
import disciplinaryActivity from '@/api/disciplinary-activity'
import { baseState, baseMutations } from '@/store/mixins'
import moment from 'moment'

export const state = {
  ...baseState,
  disciplinarySubTypes: [],
  disciplinaryActivities: [],
  dis_sub_type_id: undefined,
  dis_activity_id: undefined,
  date_from: moment().add(-7, 'Day').format('DD-MM-YYYY'),
  date_to: moment().format('DD-MM-YYYY')
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_DATE_FROM (state, date) {
    state.date_from = date
  },
  SET_DATE_TO (state, date) {
    state.date_to = date
  },
  SET_DISCIPLINARY_SUB_TYPES (state, data) {
    state.disciplinarySubTypes = data
  },
  SET_DISCIPLINARY_ACTIVITIES (state, data) {
    state.disciplinaryActivities = data
  },
  SET_DIS_SUB_TYPE_ID (state, data) {
    state.dis_sub_type_id = data
  },
  SET_DIS_ACTIVITY_ID (state, data) {
    state.dis_activity_id = data
  }
}

export const actions = {
  fetch (context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search,
        dis_activity_id: context.state.dis_activity_id,
        dis_sub_type_id: context.state.dis_sub_type_id,
        date_from: context.state.date_from,
        date_to: context.state.date_to
      },
      attributes
    )

    return disciplinaryRecord.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  create (context, data) {
    return disciplinaryRecord.store(data)
  },

  async find (context, id) {
    return await disciplinaryRecord.find(id)
  },

  update (context, data) {
    return disciplinaryRecord.update(data)
  },

  delete (context, data) {
    return disciplinaryRecord.destroy(data)
  },
  fetchDisciplinarySubType (context) {
    return disciplinarySubType
      .get({
        params: {
          fields: {
            disciplinary_sub_types:
              'dis_sub_type_id,dis_sub_type_kh,dis_sub_type_en,att_status_id'
          },
          filter: {
            att_status_id_is_null: true
          },
          page: -1
        },
        headers: {
          'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
        }
      })
      .then(response => {
        // const dataFilter = response.data.filter(item => item.att_status_id === null)
        // context.commit('SET_DISCIPLINARY_SUB_TYPES', dataFilter)

        context.commit('SET_DISCIPLINARY_SUB_TYPES', response.data)
      })
      .catch(error => {
        Promise.reject(error.data)
      })
  },
  fetchDisciplinaryActivity (context) {
    return disciplinaryActivity
      .get({
        params: {
          fields: {
            disciplinary_activities:
              'dis_activity_id,dis_activity_kh,dis_activity_en,penalty_type_id'
          },
          filter: {
            penalty_type_id_null: true
          },
          page: -1
        },
        headers: {
          'X-PERMISSION-ALLOW-CODE': context.rootGetters.permissionAllowCode
        }
      })
      .then(response => {
        context.commit('SET_DISCIPLINARY_ACTIVITIES', response.data)
      })
      .catch(error => {
        Promise.reject(error.data)
      })
  },
  getSubject (context, student_id) {
    return disciplinaryRecord.subject({
      params: { student_id: student_id }
    })
  },
  getSubType (context, data) {
    return disciplinaryRecord.subType(data)
  },
  getActivity (context, data) {
    return disciplinaryRecord.activity(data)
  },
  printPdf (context, data) {
    return disciplinaryRecord.previewPdf({ params: data })
  }
}
